import React, { useState } from 'react';
import styled from 'styled-components';
import { LinkButton } from '../../../../CommonComponents/Button';
import Modal from '../../../../CommonComponents/Modal';

const ModalWrapper = styled.div`
  padding: 64px;
  font-size: 16px;
  color: #444;
  max-width: 960px;

  p {
    margin: 24px 0;
  }
`;

const StyledDisclosure = styled.div`
  text-align: center;
  font-size: 12px;
  position: relative;
  padding-top: 12px;
`;

const Popup = styled.div`
  box-sizing: border-box;
  position: absolute;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 4px;
  left: 50%;
  top: 0;
  transform: translate(-50%, -100%);
  width: 342px;
  padding: 24px;
  z-index: 3;
  text-align: left;
  color: #444;
  font-size: 12px;

  p {
    margin-top: 0;
    line-height: 20px;
  }
`;

const Trigger = styled.div`
  color: #767676;
  cursor: default;
`;

const StyledLinkButton = styled(LinkButton)`
  color: #0078D4;
  font-size: 12px;
  font-weight: 600;
`;

const Disclosure = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Modal isOpen={showModal} onRequestClose={() => setShowModal(false)} showCloseModalCross>
        <ModalWrapper>
          <p>
            VantageScore 3.0, with scores ranging from 300 to 850, is a user-friendly credit score
            model developed by the three major nationwide credit reporting agencies, Experian®,
            TransUnion®, and Equifax®. VantageScore 3.0 is used by some but not all lenders. Higher
            scores represent a greater likelihood that you&apos;ll pay back your debts so you are
            viewed as being a lower credit risk to lenders. A lower score indicates to lenders that
            you may be a higher credit risk.
          </p>
          <p>
            There are three different major credit reporting agencies, Experian, TransUnion, and
            Equifax that maintain a record of your credit history known as your credit file. Credit
            scores are based on the information in your credit file at the time it is requested.
            Your credit file information can vary from agency to agency because some lenders report
            your credit history to only one or two of the agencies. So your credit scores can vary
            if the information they have on file for you is different. Since the information in your
            file can change over time, your credit scores also may be different from day-to-day.
            Different credit scoring models can also give a different assessment of the credit risk
            (risk of default) for the same consumer and same credit file.
          </p>
          <p>
            There are different credit scoring models which may be used by lenders and insurers.
            Your lender may not use VantageScore 3.0, so don&apos;t be surprised if your lender
            gives you a score that&apos;s different from your VantageScore. (And your VantageScore
            3.0 may differ from your score under other types of VantageScores). Just remember that
            your associated risk level is often the same even if the number is not. For some
            consumers, however, the risk assessment of VantageScore 3.0 could vary, sometimes
            substantially, from a lender’s score. If the lender&apos;s score is lower than your
            VantageScore 3.0, it is possible that this difference can lead to higher interest rates
            and sometimes credit denial.
          </p>
        </ModalWrapper>
      </Modal>
      <StyledDisclosure
        onMouseEnter={() => setShowPopup(true)}
        onMouseLeave={() => setShowPopup(false)}
      >
        {showPopup && (
          <Popup>
            <p>
              Calculated on the VantageScore 3.0 model. Your VantageScore 3.0 from Experian
              indicates your credit risk level and is not used by all lenders, so don&apos;t be
              surprised if your lender uses a score that&apos;s different from your VantageScore
              3.0.
            </p>
            <StyledLinkButton
              onClick={() => {
                setShowModal(true);
                setShowPopup(false);
              }}
            >
              Learn more about credit scores
            </StyledLinkButton>
          </Popup>
        )}
        <Trigger>
          Calculated using VantageScore 3.0 <i className="fas fa-question-circle" />
        </Trigger>
      </StyledDisclosure>
    </>
  );
};

export default Disclosure;
